import React from 'react';
import { generatePath, Link } from 'react-router-dom';

import { useCustomTheme } from '../../../../../../../hooks/useCustomTheme';
import { DYNAMIC_PAGE_PATHS } from '../../../../../../views/DynamicPageView/config/shared/pathRoutes';
import { PayoutsListRowProps } from '../../../types/PayoutsListRowProps';

export const toPayoutDetailFieldColumn = ({ flex }: { flex?: number }) => {
  const { palette, customBorderRadius } = useCustomTheme();
  return {
    flex: flex ?? 0.15,
    field: 'to_detail',
    sortable: false,
    headerName: ' ',
    disableOnRowClick: true,
    renderCell: (rowData: PayoutsListRowProps) => {
      return (
        <Link
          to={generatePath(DYNAMIC_PAGE_PATHS.PAYOUT, { payoutId: rowData.row.id })}
          style={{
            minWidth: '40px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            paddingLeft: '0px',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: palette.grey[100],
              width: 24,
              height: 24,
              borderRadius: customBorderRadius.button,
            }}
          >
            <i
              className="material-icons-outlined"
              style={{
                verticalAlign: 'sub',
                fontSize: '20px',
                color: palette.text.primary,
              }}
            >
              {'chevron_right'}
            </i>
          </div>
        </Link>
      );
    },
  };
};
